import FilterBar from './FilterBar/FilterBar.component';
import PropertiesOnMap from './PropertiesOnMap/PropertiesOnMap.component';
import Properties from './Properties/Properties.component';
import Detail from './Detail/Detail.component';
import Pagination from './Pagination/Pagination.component';

export {
  FilterBar,
  PropertiesOnMap,
  Properties,
  Detail,
  Pagination
}
